import { IOpenPanel } from "../../../../Interfaces/IPanel";
import { usePanelCargaMasivaSupervisores } from "./usePanelCargaMasivaSupervisores";
import { useCallback, useEffect, useRef, useState } from "react";
import { useIconsCatalogo } from "../../../../components/iconCatalog/common.useIconsCatalogo";
import { Pivot, PivotItem, DefaultButton, Panel, PanelType } from "@fluentui/react";
import { PanelHeader } from "../../../../components/Panel/PanelHeader";
import { PanelFooter } from "../../../../components/Panel/PanelFooter";
import { IColumn } from "../../../../Interfaces/filter";
import { TableComponent } from "../../../../components/Table/TableComponent";
import { MensajeBar } from "../../../../components/generic/ManejoResponseMessage/MessageBar";
import IdicadorProgress from "../../../../components/generic/IndicadorProgress";

export const PanelCargaMasivaSupervisores = (props: IOpenPanel) => {

    const inputRef = useRef<HTMLInputElement>(null);
    const { Icon } = useIconsCatalogo();
    const [isHover, setIsHover] = useState(false);
    const [selectedValue, setSelectedValue] = useState<string>("Carga");
    const dragCounter = useRef(0);
    const [isDragActive, setIsDragActive] = useState(false);

    const {
        isSubmit,
        loader,
        loading,
        excelFile,
        response,
        request,
        log,
        subirDocumento,
        subir,
        limpiarResponse,
        descargarPlantilla,
        eliminarDocumento
    } = usePanelCargaMasivaSupervisores(props);

    useEffect(() => {
        if (!props.isOpen) {
        setSelectedValue("Carga");
        }
    }, [props.isOpen]);

    const _column: IColumn[] = [
    { key: 0, name: "Fila", minWidth: 30, maxWidth: 30, fieldName: "fila" },
    { key: 1, name: "Operador", minWidth: 90, maxWidth: 90, fieldName: "codigoOperador" },
    { key: 2, name: "Supervisor", minWidth: 90, maxWidth: 90, fieldName: "codigoSupervisor" },
    {
      key: 3,
      name: "Observación",
      minWidth: 300,
      maxWidth: 300,
      fieldName: "mensaje",
      isMultiline:true
    },
  ];

    const onRenderFooterPanel = useCallback(
        () => (
          <>
            <PanelFooter
              onClick={() => excelFile && subir(excelFile)}
              onDismiss={props.onDismiss}
              texto="Subir"
              disableButton={selectedValue !== "Carga" || !excelFile?.file}
            />
          </>
        ),
        [excelFile, subir, selectedValue, props.onDismiss]
      );

    const onRenderHeaderPanel = useCallback(
        () => (
          <>
            <PanelHeader
              key={"cargaMasiva"}
              nameIconHeader="BulkUpload"
              subTextHeader="Registre los supervisores de manera masiva."
              textHeader="Carga Masiva de Supervisores"
            />
          </>
        ),
        []
      );

    return (
        <Panel
            isOpen={props.isOpen}
            onDismiss={props.onDismiss}
            onRenderHeader={onRenderHeaderPanel}
            onRenderFooter={onRenderFooterPanel}
            isFooterAtBottom={true}
            closeButtonAriaLabel="Close"
            customWidth="950px"
            type={PanelType.custom}
            isLightDismiss={false}
        >
            <>
                {response && (
                    <MensajeBar
                        response={{ mensaje: response.mensaje || "", codigoMensaje: response.codigoMensaje || 0 }}
                        ocultar={() => limpiarResponse()}
                    />
                )}
                {loading ? (
                    <IdicadorProgress isSend={loading} subText="Cargando..." />
                ) : (
                    <>
                        <section
                            style={{
                            height: response?.mensaje ? "calc(100% - 60px)" : "98%",
                            display: "flex",
                            flexDirection: "column",
                            }}
                        >
                <Pivot
                    aria-label="Carga Masiva Tabs"
                    selectedKey={selectedValue}
                    onLinkClick={(item) => {
                        if (item && item.props.itemKey === "Logs" && log.length === 0) {
                            return;
                        }
                        item && setSelectedValue(item.props.itemKey || "Carga");
                    }}
                    styles={{
                        root: { marginBottom: "10px" }
                    }}
                >
                    <PivotItem headerText="Cargar Archivo" itemKey="Carga" />
                    <PivotItem 
                        headerText={`Observaciones ${log.length > 0 ? `(${log.length})` : ""}`} 
                        itemKey="Logs"
                    />
                </Pivot>

                {selectedValue === "Carga" ? (
                <>
                    <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "10px",
                    }}
                    >
                    <DefaultButton
                        onClick={descargarPlantilla}
                        disabled={loader}
                        iconProps={{ iconName: "Download" }}
                        text={loader ? "Descargando..." : "Descargar Plantilla"}
                    />
                    <DefaultButton
                        onClick={eliminarDocumento}
                        disabled={excelFile === null || excelFile === undefined}
                        iconProps={{ iconName: "Delete" }}
                        text="Eliminar Archivo"
                        styles={{
                            root: {
                                color: excelFile === null ? "#B0B0B0" : "#F44336",
                            },
                            icon: {
                                color: excelFile === null ? "#B0B0B0" : "#F44336",
                            }
                        }}
                    />
                    </div>
                    <article
                    onDragOver={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                    }}
                    onDragEnter={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        dragCounter.current += 1;
                        setIsDragActive(true);
                    }}
                    onDragLeave={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        dragCounter.current -= 1;
                        if (dragCounter.current === 0) {
                        setIsDragActive(false);
                        }
                    }}
                    onDrop={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        dragCounter.current = 0;
                        setIsDragActive(false);
                        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
                        const fileList = e.dataTransfer.files;
                        const event = { target: { files: fileList } };
                        subirDocumento(event as any);
                        }
                    }}
                    style={{
                        minHeight: "350px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        border: isDragActive ? "2px dashed #1267b4" : "none",
                        background: isDragActive ? "#e4effaff" : "transparent",
                        borderRadius: "10px",
                        position: "relative",
                        transition: "border 0.2s ease-in-out, background 0.2s ease-in-out",
                    }}
                    >
                    {/* Botón central (siempre visible) */}
                    <div
                        onClick={() => inputRef.current?.click()}
                        onMouseEnter={() => setIsHover(true)}
                        onMouseLeave={() => setIsHover(false)}
                        style={{
                        width: "200px",
                        height: "200px",
                        border: `${
                            isDragActive
                            ? "none"
                            : excelFile?.file
                            ? "0px solid #d1d1d1"
                            : "1px solid #d1d1d1"
                        }`,
                        borderRadius: "8px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        color: isDragActive ? "#1267b4" : "",
                        alignItems: "center",
                        cursor: "pointer",
                        backgroundColor: isDragActive ? "transparent" : "#ffffff",
                        zIndex: 2,
                        }}
                    >
                        <div style={{ fontSize: "50px", marginBottom: "10px" }}>
                        {excelFile?.file ? (
                            <span style={{ color: "#4CAF50" }}>📄✓</span>
                        ) : isHover || isDragActive ? (
                            <span style={{ color: "#1267b4" }}>📄+</span>
                        ) : (
                            <span style={{ color: "#666" }}>📄</span>
                        )}
                        </div>
                        <span
                        style={{ color: "black", textAlign: "center", width: "60%" }}
                        >
                        {excelFile?.file
                            ? "Archivo Subido"
                            : isDragActive
                            ? "Suelte el archivo excel aquí"
                            : "Suba o arrastre el archivo excel"}
                        </span>
                        {excelFile?.file && (
                        <div
                            style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            marginTop: "5px",
                            }}
                        >
                            <span style={{ fontSize: "11.5px", color: "#717171" }}>
                            {excelFile.nombreArchivo}
                            </span>
                            <span style={{ fontSize: "11.5px", color: "#717171" }}>
                            {excelFile.tamanio} bytes
                            </span>
                        </div>
                        )}
                    </div>
                    </article>
                </>
                ) : (
                <div
                    style={{
                    width: "100%",
                    height: "98%",
                    display: "flex",
                    gap: "8px",
                    flexDirection: "column",
                    }}
                >
                    <TableComponent
                        column={_column}
                        data={log}
                        hiddenBorder
                        leftButtons={[]}
                        rightButton={[]}
                        isLoading={false}
                    />
                </div>
                )}
                    </section>
                </>
                )}
            </>

            <input
                ref={inputRef}
                type="file"
                accept=".xls,.xlsx"
                hidden
                onChange={subirDocumento}
            />
        </Panel>
    );
}